/*
 * Color + Size filters parsed from each product card's variant titles.
 * Used when Shopify has no native Color/Size options (WPS "Option" string).
 * Extra collection pages are scanned so the filter is not limited to page 1.
 */
(function () {
  'use strict';

  var LETTER_SIZE = /^(XXS|XS|S|SM|SML|M|MD|MED|L|LG|XL|XXL|XXXL|2XS|3XS|2X|2XL|3X|3XL|4X|4XL|5X|5XL|OS|YXS|YS|YM|YL|YXL)$/i;
  var SIZE_RANGE = /^(XXS|XS|S|SM|SML|M|MD|MED|L|LG|XL|XXL|2X|2XL|3X|3XL|YS|YM|YL)\/(XXS|XS|S|SM|SML|M|MD|MED|L|LG|XL|XXL|2X|2XL|3X|3XL|YS|YM|YL)$/i;
  var NUM_SIZE = /^\d{1,2}(\.5)?$/;
  var SIZE_ORDER = ['3XS', '2XS', 'XXS', 'XS', 'YXS', 'YS', 'YM', 'YL', 'YXL', 'S', 'SM', 'SML', 'M', 'MD', 'MED', 'L', 'LG', 'XL', 'XXL', '2X', '2XL', 'XXXL', '3X', '3XL', '4X', '4XL', '5X', '5XL', 'OS', 'ONE SIZE'];
  var SIZE_LABEL = { SM: 'S', SML: 'S', MD: 'M', MED: 'M', LG: 'L', '2X': '2XL', '3X': '3XL', '4X': '4XL', '5X': '5XL', XXL: '2XL', XXXL: '3XL', XXS: '2XS', OS: 'One size' };
  var COLORS = {
    black: '#111111', white: '#ffffff', red: '#d6001c', blue: '#1f5fbf', green: '#1f8a3b', yellow: '#f2c200',
    orange: '#f26a1b', pink: '#e86aa3', purple: '#6b3fa0', gray: '#8a8a8a', grey: '#8a8a8a', silver: '#c4c4c4',
    brown: '#7a4a21', tan: '#c9a77c', navy: '#14284b', gold: '#c9a227', teal: '#159a9c', cyan: '#19b5d8',
    lime: '#9acd32', charcoal: '#36393d', cream: '#f2ead3', maroon: '#6d1020', burgundy: '#6d1020', olive: '#6b7040',
    khaki: '#b5a77a', camo: '#6b7040', magenta: '#c2187a', clear: '#e8eef2', smoke: '#6f7479', bronze: '#8c6239',
    blk: '#111111', wht: '#ffffff', gry: '#8a8a8a', ylw: '#f2c200', orng: '#f26a1b', rd: '#d6001c', blu: '#1f5fbf',
    fluo: '#c8ff00', neon: '#c8ff00', carbon: '#1a1a1a'
  };
  var COLOR_SKIP = /^(matte|matt|gloss|glossy|fluorescent|solid|metallic|pearl|satin|finish|helmet|visor|size|sz)$/i;
  var MAX_EXTRA_PAGES = 10;
  var extraCache = {};
  var extraAbort = null;

  function isSizeTok(tok) {
    return LETTER_SIZE.test(tok) || SIZE_RANGE.test(tok);
  }

  function normSize(tok) {
    var u = String(tok).toUpperCase();
    return SIZE_LABEL[u] || u;
  }

  function titleCase(text) {
    return String(text)
      .toLowerCase()
      .replace(/(^|[\s/(-])([a-z])/g, function (m, p, c) {
        return p + c.toUpperCase();
      })
      .split(' ')
      .map(function (w) {
        return /\d/.test(w) || w.length <= 2 ? w.toUpperCase() : w;
      })
      .join(' ');
  }

  function isColorish(tok) {
    var parts = String(tok).split(/[\/,]/);
    return parts.some(function (p) {
      var w = p.replace(/[^a-z]/gi, '').toLowerCase();
      return !!w && (!!COLORS[w] || COLOR_SKIP.test(w) || /^(hi|hiviz|viz|vis|phantom|graphite|lunar|cement|anthracite|titanium|stealth|carbon|camo|neon|fluo)$/i.test(w));
    });
  }

  function extractColor(tokens) {
    var colorToks = [];
    for (var i = tokens.length - 1; i >= 0; i--) {
      var tok = tokens[i];
      if (isColorish(tok) || /[\/]/.test(tok)) colorToks.unshift(tok);
      else if (colorToks.length) break;
    }
    if (!colorToks.length && tokens.length) colorToks = tokens.slice(-2);
    return colorToks.join(' ').trim();
  }

  function parseTitle(title) {
    var cleaned = String(title || '').replace(/\([^)]*\)/g, ' ').trim();
    var t = cleaned.split(/\s+/).filter(Boolean);
    if (!t.length) return { color: '', size: '' };
    var size = '';
    var sizeIdx = -1;
    for (var i = t.length - 1; i >= 0; i--) {
      var tok = t[i].replace(/[().,]/g, '');
      if (isSizeTok(tok) || (NUM_SIZE.test(tok) && parseFloat(tok) <= 20)) {
        size = normSize(tok);
        sizeIdx = i;
        break;
      }
    }
    var body = sizeIdx >= 0 ? t.slice(0, sizeIdx) : t.slice();
    if (body.length && /^(SZ|SIZE)$/i.test(body[body.length - 1])) body.pop();
    var visorAt = -1;
    body.forEach(function (tok, idx) {
      if (/^VISOR$/i.test(tok)) visorAt = idx;
    });
    if (visorAt >= 0) body = body.slice(visorAt + 1);
    var color = extractColor(body);
    color = color.replace(/^(helmet|modular|youth|jersey|glove|gloves|boot|boots|jacket)s?\s+/i, '').trim();
    if (/^(standard|default|title|option|helmet|modular|youth)$/i.test(color)) color = '';
    return { color: color, size: size };
  }

  function parseOpts(raw) {
    return String(raw || '')
      .split('||')
      .map(function (s) {
        return s.trim();
      })
      .filter(Boolean)
      .map(parseTitle);
  }

  function colorKey(name) {
    var abbrev = { blk: 'black', wht: 'white', gry: 'grey', ylw: 'yellow', orng: 'orange', rd: 'red', blu: 'blue' };
    return String(name || '')
      .toLowerCase()
      .replace(/\b(blk|wht|gry|ylw|orng|rd|blu)\b/g, function (m) {
        return abbrev[m] || m;
      })
      .replace(/\s+/g, ' ')
      .trim();
  }

  function swatchStyle(colorName) {
    var parts = String(colorName).toLowerCase().split(/[\/,]/);
    var found = [];
    parts.forEach(function (part) {
      var words = part.trim().split(/\s+/);
      for (var i = 0; i < words.length; i++) {
        var w = words[i].replace(/[^a-z]/g, '');
        if (!w || COLOR_SKIP.test(w)) continue;
        if (COLORS[w]) {
          found.push(COLORS[w]);
          break;
        }
      }
    });
    if (!found.length) return '';
    if (found.length === 1) return found[0];
    return 'linear-gradient(135deg,' + found[0] + ' 50%,' + found[1] + ' 50%)';
  }

  function hashColor(name) {
    var h = 0;
    String(name).split('').forEach(function (c) {
      h = (h * 31 + c.charCodeAt(0)) | 0;
    });
    return 'hsl(' + (Math.abs(h) % 360) + ' 18% 52%)';
  }

  function cardVariants(card) {
    if (card._smartParsed) return card._smartParsed;
    card._smartParsed = parseOpts(card.getAttribute('data-smart-opts'));
    return card._smartParsed;
  }

  function cardMatches(card, colors, sizes) {
    var rows = cardVariants(card);
    if (!rows.length) return !colors.length && !sizes.length;
    return rows.some(function (row) {
      var colorOk = !colors.length || (row.color && colors.indexOf(colorKey(row.color)) !== -1);
      var sizeOk = !sizes.length || (row.size && sizes.indexOf(row.size) !== -1);
      return colorOk && sizeOk;
    });
  }

  function collectFromCards(cards) {
    var colors = {};
    var sizes = {};
    cards.forEach(function (card) {
      cardVariants(card).forEach(function (row) {
        if (row.color) {
          var k = colorKey(row.color);
          if (k && !colors[k]) colors[k] = titleCase(row.color);
        }
        if (row.size) sizes[row.size] = row.size;
      });
    });
    return { colors: colors, sizes: sizes };
  }

  function selectedValues(section, name) {
    var out = [];
    section.querySelectorAll('input[data-smart-filter][name="' + name + '"]:checked').forEach(function (input) {
      if (out.indexOf(input.value) === -1) out.push(input.value);
    });
    return out;
  }

  function hasNativeFilter(section, kind) {
    var nodes = section.querySelectorAll('input[name^="filter."]');
    for (var i = 0; i < nodes.length; i++) {
      var n = String(nodes[i].getAttribute('name') || '').toLowerCase();
      if (n.indexOf('option.' + kind) !== -1) return true;
      if (kind === 'color' && n.indexOf('color-pattern') !== -1) return true;
    }
    return false;
  }

  function readUrlSelection() {
    var params = new URLSearchParams(window.location.search);
    return {
      colors: params.getAll('sc').map(colorKey).filter(Boolean),
      sizes: params.getAll('ss').filter(Boolean)
    };
  }

  function writeUrlSelection(colors, sizes) {
    var url = new URL(window.location.href);
    url.searchParams.delete('sc');
    url.searchParams.delete('ss');
    colors.forEach(function (c) {
      url.searchParams.append('sc', c);
    });
    sizes.forEach(function (s) {
      url.searchParams.append('ss', s);
    });
    window.history.replaceState(window.history.state || {}, '', url.pathname + url.search);
  }

  function pagerInfo(section) {
    var max = 1;
    var current = 1;
    var cur = section.querySelector('.pager__link.is-current');
    if (cur) current = parseInt(cur.textContent, 10) || 1;
    section.querySelectorAll('.pager a[href]').forEach(function (a) {
      try {
        var u = new URL(a.href, window.location.origin);
        var p = parseInt(u.searchParams.get('page') || '1', 10);
        if (p > max) max = p;
      } catch (e) {}
    });
    if (current > max) max = current;
    return { current: current, max: max };
  }

  function buildGroup(label, name, entries, selected, asChips) {
    var details = document.createElement('details');
    details.className = 'facets__details';
    details.open = true;
    details.setAttribute('data-facet-details', '');
    details.setAttribute('data-smart-filter-group', name);

    var summary = document.createElement('summary');
    summary.className = 'facets__summary';
    summary.textContent = label;
    details.appendChild(summary);

    var panel = document.createElement('div');
    panel.className = 'facets__panel';
    var inner = document.createElement('div');
    inner.className = 'facets__panel-inner';

    if (entries.length > 8) {
      var search = document.createElement('input');
      search.className = 'facets__search';
      search.type = 'search';
      search.placeholder = 'Search…';
      search.setAttribute('data-facet-search', '');
      inner.appendChild(search);
    }

    var ul = document.createElement('ul');
    ul.className = 'facets__list' + (asChips ? ' facets__list--chips' : '');
    ul.setAttribute('data-facet-list', '');
    ul.setAttribute('data-preview-limit', '9999');

    entries.forEach(function (entry) {
      var li = document.createElement('li');
      li.className = 'facets__item';
      li.setAttribute('data-facet-item', '');
      li.setAttribute('data-label', entry.label.toLowerCase());

      var lab = document.createElement('label');
      lab.className = 'facets__label';

      var input = document.createElement('input');
      input.className = 'facets__checkbox';
      input.type = 'checkbox';
      input.name = name;
      input.value = entry.value;
      input.checked = selected.indexOf(entry.value) !== -1;
      input.setAttribute('data-smart-filter', name);

      var text = document.createElement('span');
      text.className = 'facets__label-text';
      if (asChips) {
        var sw = document.createElement('span');
        sw.className = 'facets__swatch';
        sw.style.background = swatchStyle(entry.label) || hashColor(entry.label);
        text.appendChild(sw);
      }
      text.appendChild(document.createTextNode(' ' + entry.label));

      lab.appendChild(input);
      lab.appendChild(text);
      li.appendChild(lab);
      ul.appendChild(li);
    });

    inner.appendChild(ul);
    panel.appendChild(inner);
    details.appendChild(panel);
    return details;
  }

  function sortSizes(keys) {
    return keys.slice().sort(function (a, b) {
      var ia = SIZE_ORDER.indexOf(String(a).toUpperCase());
      var ib = SIZE_ORDER.indexOf(String(b).toUpperCase());
      if (ia < 0 && ib < 0) {
        var na = parseFloat(a);
        var nb = parseFloat(b);
        if (!isNaN(na) && !isNaN(nb)) return na - nb;
        return String(a).localeCompare(String(b));
      }
      if (ia < 0) return 1;
      if (ib < 0) return -1;
      return ia - ib;
    });
  }

  function insertGroups(form, colors, sizes, selected, showColor, showSize) {
    if (!form) return;
    form.querySelectorAll('[data-smart-filter-group]').forEach(function (node) {
      node.remove();
    });
    var anchor = form.querySelector('.facets__details:last-of-type') || form.lastElementChild;
    if (showColor && colors.length) {
      var colorGroup = buildGroup('Color', 'sc', colors, selected.colors, true);
      if (anchor) anchor.after(colorGroup);
      else form.appendChild(colorGroup);
      anchor = colorGroup;
    }
    if (showSize && sizes.length) {
      var sizeGroup = buildGroup('Size', 'ss', sizes, selected.sizes, true);
      if (anchor) anchor.after(sizeGroup);
      else form.appendChild(sizeGroup);
    }
  }

  function updateStatus(section, shown, scanning) {
    var status = section.querySelector('.pager__status');
    var pager = section.querySelector('.pager');
    var empty = section.querySelector('[data-smart-empty]');
    var grid = section.querySelector('[data-product-grid]');
    if (pager) pager.classList.toggle('is-smart-hidden', shown.filtering);
    if (status && shown.filtering) {
      status.hidden = false;
      status.textContent = scanning
        ? 'Finding matching gear…'
        : 'Showing ' + shown.count + ' match' + (shown.count === 1 ? '' : 'es');
    }
    if (!empty && grid) {
      empty = document.createElement('p');
      empty.className = 'collection-empty';
      empty.setAttribute('data-smart-empty', '');
      empty.hidden = true;
      empty.textContent = 'No products match those color or size filters.';
      grid.after(empty);
    }
    if (empty) empty.hidden = !shown.filtering || shown.count > 0 || scanning;
  }

  function applyToCards(cards, colors, sizes) {
    var count = 0;
    cards.forEach(function (card) {
      var ok = cardMatches(card, colors, sizes);
      card.classList.toggle('is-smart-hidden', !ok);
      if (ok) count += 1;
    });
    return count;
  }

  function originalCards(section) {
    return Array.prototype.slice.call(section.querySelectorAll('[data-product-grid] > .product-card:not([data-smart-extra])'));
  }

  function allCards(section) {
    return Array.prototype.slice.call(section.querySelectorAll('[data-product-grid] .product-card'));
  }

  function syncForms(section, source) {
    var name = source.getAttribute('name');
    var value = source.value;
    section.querySelectorAll('input[data-smart-filter][name="' + name + '"][value="' + CSS.escape(value) + '"]').forEach(function (input) {
      input.checked = source.checked;
    });
  }

  function fetchPage(section, page) {
    var id = section.getAttribute('data-section-id');
    var url = new URL(window.location.href);
    url.searchParams.delete('sc');
    url.searchParams.delete('ss');
    url.searchParams.delete('sections');
    url.searchParams.set('page', String(page));
    var key = url.pathname + url.search;
    if (extraCache[key]) return Promise.resolve(extraCache[key]);
    var fetchUrl = url.pathname + '?' + url.searchParams.toString() + '&sections=' + encodeURIComponent(id);
    return fetch(fetchUrl, { credentials: 'same-origin', signal: extraAbort && extraAbort.signal }).then(function (res) {
      if (!res.ok) throw new Error('page fetch');
      return res.json();
    }).then(function (data) {
      var html = data[id];
      if (!html) return [];
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var cards = Array.prototype.slice.call(doc.querySelectorAll('[data-product-grid] .product-card'));
      extraCache[key] = cards;
      return cards;
    });
  }

  function scanExtraPages(section, colors, sizes) {
    var info = pagerInfo(section);
    var max = Math.min(info.max, MAX_EXTRA_PAGES);
    if (max <= 1) return Promise.resolve();
    if (extraAbort) extraAbort.abort();
    extraAbort = new AbortController();
    var pages = [];
    for (var p = 1; p <= max; p++) {
      if (p !== info.current) pages.push(p);
    }
    var grid = section.querySelector('[data-product-grid]');
    if (!grid) return Promise.resolve();

    return pages.reduce(function (chain, page) {
      return chain.then(function () {
        if (!document.body.contains(section)) return;
        return fetchPage(section, page).then(function (cards) {
          cards.forEach(function (card) {
            if (!cardMatches(card, colors, sizes)) return;
            var href = card.getAttribute('href');
            if (href && grid.querySelector('.product-card[href="' + href + '"]')) return;
            var clone = card.cloneNode(true);
            clone.setAttribute('data-smart-extra', '1');
            clone.classList.remove('is-smart-hidden');
            grid.appendChild(clone);
          });
        }).catch(function () {});
      });
    }, Promise.resolve());
  }

  function bind(section) {
    if (section.dataset.smartBound === '1') return;
    section.dataset.smartBound = '1';
    section.addEventListener('change', function (event) {
      var target = event.target;
      if (!(target instanceof HTMLInputElement) || !target.hasAttribute('data-smart-filter')) return;
      event.stopPropagation();
      syncForms(section, target);
      run(section, true);
    });
  }

  function run(section, fromUser) {
    var grid = section.querySelector('[data-product-grid]');
    if (!grid) return;

    section.querySelectorAll('[data-smart-extra]').forEach(function (card) {
      card.remove();
    });

    var locals = originalCards(section);
    var mined = collectFromCards(locals);
    var colorEntries = Object.keys(mined.colors)
      .sort()
      .map(function (k) {
        return { value: k, label: mined.colors[k] };
      });
    var sizeEntries = sortSizes(Object.keys(mined.sizes)).map(function (k) {
      return { value: k, label: k };
    });

    var showColor = colorEntries.length > 1 && !hasNativeFilter(section, 'color');
    var showSize = sizeEntries.length > 1 && !hasNativeFilter(section, 'size');
    if (!showColor && !showSize) return;

    var selected = fromUser
      ? { colors: selectedValues(section, 'sc'), sizes: selectedValues(section, 'ss') }
      : readUrlSelection();

    selected.colors.forEach(function (c) {
      if (c && !mined.colors[c]) mined.colors[c] = titleCase(c);
    });
    selected.sizes.forEach(function (s) {
      if (s && !mined.sizes[s]) mined.sizes[s] = s;
    });
    colorEntries = Object.keys(mined.colors)
      .sort()
      .map(function (k) {
        return { value: k, label: mined.colors[k] };
      });
    sizeEntries = sortSizes(Object.keys(mined.sizes)).map(function (k) {
      return { value: k, label: k };
    });

    section.querySelectorAll('[data-facets-form]').forEach(function (form) {
      insertGroups(form, colorEntries, sizeEntries, selected, showColor, showSize);
    });

    var filtering = selected.colors.length + selected.sizes.length > 0;
    writeUrlSelection(selected.colors, selected.sizes);
    var count = applyToCards(locals, selected.colors, selected.sizes);
    updateStatus(section, { filtering: filtering, count: count }, filtering);

    if (!filtering) {
      var status = section.querySelector('.pager__status');
      if (status && status.dataset.original) status.textContent = status.dataset.original;
      return;
    }

    scanExtraPages(section, selected.colors, selected.sizes).then(function () {
      if (!document.body.contains(section)) return;
      count = applyToCards(allCards(section), selected.colors, selected.sizes);
      updateStatus(section, { filtering: true, count: count }, false);
    });
  }

  window.BSRInitSmartFilters = function () {
    var section = document.querySelector('[data-collection-section]');
    if (!section) return;
    var status = section.querySelector('.pager__status');
    if (status && !status.dataset.original) status.dataset.original = status.textContent;
    bind(section);
    run(section, false);
  };
})();
